/* Bundle picker (snippets/aa-bundle-picker.liquid). Replaces the Kaching Bundles app:
   pick a tier, set each item's options, add them all to the cart in one request. */
if (!customElements.get('aa-bundle-picker')) {
  customElements.define(
    'aa-bundle-picker',
    class AaBundlePicker extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        try {
          this.cfg = JSON.parse(this.querySelector('script[data-aa-bundle]').textContent);
        } catch (e) {
          return;
        }
        this.form = document.getElementById(this.dataset.form);
        this.status = this.querySelector('.aa-bundle__status');
        this.byKey = {};
        this.cfg.variants.forEach((v) => (this.byKey[v.options.join('\u0001')] = v));

        this.addEventListener('change', (e) => {
          if (e.target.type === 'radio') this.pickTier(e.target.closest('.aa-bundle__tier'));
          else if (e.target.classList.contains('aa-bundle__select')) {
            this.status.textContent = '';
            this.update();
          }
        });
        this.addEventListener('click', (e) => {
          const a = e.target.closest('[data-guide]');
          if (a) {
            e.preventDefault();
            this.openGuide(a.dataset.guide);
          }
        });
        if (this.form) {
          // capture runs before Dawn's product-form submit handler on the same form
          this.form.addEventListener('submit', (e) => this.onSubmit(e), true);
          const btn = this.form.querySelector('[type="submit"]');
          if (btn && btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
        }
        this.querySelectorAll('[data-guide]').forEach((a) => {
          if (this.findGuide(a.dataset.guide)) a.closest('.aa-bundle__help').hidden = false;
        });
        this.buildMenus();
        this.update();
      }

      /* Each option menu gets a list in the site's own style instead of the operating system's.
         The real <select> stays underneath (hidden) and still drives the picker: choosing in the
         list sets it and fires its change event. If this never runs, the plain menus still work. */
      buildMenus() {
        this.check = this.querySelector('template[data-aa-check]');
        this.menus = [];
        this.querySelectorAll('.aa-bundle__select').forEach((sel) => {
          const wrap = document.createElement('span');
          wrap.className = 'aa-bdd';
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'aa-bdd__btn';
          btn.setAttribute('aria-haspopup', 'listbox');
          btn.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-label', sel.getAttribute('aria-label') || '');
          const val = document.createElement('span');
          val.className = 'aa-bdd__val';
          btn.appendChild(val);
          sel.parentNode.insertBefore(wrap, sel);
          wrap.appendChild(sel);
          wrap.appendChild(btn);
          sel.classList.add('aa-bdd__native');
          sel.tabIndex = -1;
          sel.setAttribute('aria-hidden', 'true');
          // the list is built the first time the menu opens, so pickers with many rows stay light (speed audit, 2026-10-15)
          const m = { sel, btn, list: null, wrap };
          this.menus.push(m);
          btn.addEventListener('click', () => (m.list && !m.list.hidden ? this.closeMenu(m, true) : this.openMenu(m)));
          btn.addEventListener('keydown', (e) => {
            if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) {
              e.preventDefault();
              this.openMenu(m);
            }
          });
        });
        if (this.menus.length) {
          document.addEventListener('click', (e) => {
            this.menus.forEach((m) => {
              if (m.list && !m.list.hidden && !m.wrap.contains(e.target)) this.closeMenu(m);
            });
          });
        }
      }

      buildList(m) {
        const list = document.createElement('ul');
        list.className = 'aa-bdd__list';
        list.setAttribute('role', 'listbox');
        list.tabIndex = -1;
        list.id = 'aa-bdd-' + Math.random().toString(36).slice(2);
        list.hidden = true;
        m.btn.setAttribute('aria-controls', list.id);
        Array.from(m.sel.options).forEach((o, j) => {
          if (o.value === '') return; // the menu's name is the button's placeholder, not a choice
          const li = document.createElement('li');
          li.setAttribute('role', 'option');
          li.id = list.id + '-' + j;
          li.dataset.value = o.value;
          const t = document.createElement('span');
          t.textContent = o.textContent.trim();
          li.appendChild(t);
          if (this.check) li.appendChild(this.check.content.cloneNode(true));
          list.appendChild(li);
        });
        m.wrap.appendChild(list);
        m.list = list;
        list.addEventListener('click', (e) => {
          const li = e.target.closest('[role="option"]');
          if (li && li.getAttribute('aria-disabled') !== 'true') this.choose(m, li);
        });
        list.addEventListener('mousemove', (e) => {
          const li = e.target.closest('[role="option"]');
          if (li && !li.classList.contains('is-active')) this.activate(m, li, true);
        });
        list.addEventListener('keydown', (e) => this.menuKey(m, e));
        list.addEventListener('focusout', (e) => {
          if (!m.wrap.contains(e.relatedTarget)) this.closeMenu(m);
        });
      }

      options(m) {
        return Array.from(m.list.querySelectorAll('[role="option"]'));
      }

      activate(m, li, byMouse) {
        this.options(m).forEach((o) => o.classList.toggle('is-active', o === li));
        if (li) {
          m.list.setAttribute('aria-activedescendant', li.id);
          if (!byMouse) li.scrollIntoView({ block: 'nearest' });
        }
      }

      openMenu(m) {
        this.menus.forEach((x) => x !== m && this.closeMenu(x));
        if (m.sel.disabled) return;
        if (!m.list) this.buildList(m);
        this.syncMenus();
        m.list.hidden = false;
        m.btn.setAttribute('aria-expanded', 'true');
        // open leftwards when the list would run off the right of the screen (phones)
        m.list.classList.remove('is-right');
        if (m.list.getBoundingClientRect().right > document.documentElement.clientWidth - 8) m.list.classList.add('is-right');
        const opts = this.options(m);
        this.activate(m, opts.find((o) => o.dataset.value === m.sel.value) || opts.find((o) => o.getAttribute('aria-disabled') !== 'true'));
        m.list.focus({ preventScroll: true });
      }

      closeMenu(m, refocus) {
        if (!m.list || m.list.hidden) return;
        m.list.hidden = true;
        m.btn.setAttribute('aria-expanded', 'false');
        if (refocus) m.btn.focus();
      }

      choose(m, li) {
        if (m.sel.value !== li.dataset.value) {
          m.sel.value = li.dataset.value;
          m.sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.closeMenu(m, true);
        this.syncMenus();
      }

      menuKey(m, e) {
        const opts = this.options(m).filter((o) => o.getAttribute('aria-disabled') !== 'true');
        const cur = opts.indexOf(m.list.querySelector('.is-active'));
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const n = cur + (e.key === 'ArrowDown' ? 1 : -1);
          this.activate(m, opts[Math.max(0, Math.min(opts.length - 1, n))]);
        } else if (e.key === 'Home' || e.key === 'End') {
          e.preventDefault();
          this.activate(m, opts[e.key === 'Home' ? 0 : opts.length - 1]);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (cur > -1) this.choose(m, opts[cur]);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          this.closeMenu(m, true);
        } else if (e.key === 'Tab') {
          this.closeMenu(m);
        }
      }

      // mirror each hidden <select>: its value, which choices can be bought, disabled and invalid states
      syncMenus() {
        (this.menus || []).forEach((m) => {
          const o = m.sel.options[m.sel.selectedIndex];
          const val = m.btn.querySelector('.aa-bdd__val');
          val.textContent = o ? o.textContent.trim() : '';
          m.btn.classList.toggle('is-empty', !m.sel.value);
          m.btn.disabled = m.sel.disabled;
          if (m.sel.getAttribute('aria-invalid') === 'true') {
            m.btn.setAttribute('aria-invalid', 'true');
            m.btn.setAttribute('aria-describedby', m.sel.getAttribute('aria-describedby') || '');
          } else {
            m.btn.removeAttribute('aria-invalid');
            m.btn.removeAttribute('aria-describedby');
          }
          if (!m.list) return;
          const byValue = {};
          Array.from(m.sel.options).forEach((x) => (byValue[x.value] = x));
          this.options(m).forEach((li) => {
            const x = byValue[li.dataset.value];
            li.setAttribute('aria-selected', li.dataset.value === m.sel.value ? 'true' : 'false');
            li.setAttribute('aria-disabled', x && x.disabled ? 'true' : 'false');
          });
        });
      }

      get tier() {
        const r = this.querySelector('.aa-bundle__tier > input:checked');
        return r ? r.closest('.aa-bundle__tier') : null;
      }

      rows(tier) {
        return Array.from((tier || this.tier).querySelectorAll('.aa-bundle__pair'));
      }

      values(row) {
        return Array.from(row.querySelectorAll('.aa-bundle__select')).map((s) => s.value);
      }

      pickTier(tier) {
        const prev = this.shown;
        const kept = prev && prev !== tier ? this.rows(prev).map((r) => this.values(r)) : null;
        this.querySelectorAll('.aa-bundle__tier').forEach((t) => {
          const on = t === tier;
          const pairs = t.querySelector('.aa-bundle__pairs');
          pairs.hidden = !on;
          t.querySelectorAll('.aa-bundle__select').forEach((s) => (s.disabled = !on));
        });
        if (kept && kept.length) {
          this.rows(tier).forEach((row, i) => {
            const vals = kept[Math.min(i, kept.length - 1)];
            row.querySelectorAll('.aa-bundle__select').forEach((s, j) => (s.value = vals[j]));
          });
        }
        const pairs = tier.querySelector('.aa-bundle__pairs');
        pairs.classList.remove('is-entering');
        void pairs.offsetWidth;
        pairs.classList.add('is-entering');
        this.status.textContent = '';
        this.update();
      }

      variantFor(vals) {
        return this.byKey[vals.join('\u0001')] || null;
      }

      // can these choices still be bought? blank choices (a menu still on its option's name) match any value
      canBuy(vals) {
        if (vals.indexOf('') < 0) {
          const v = this.variantFor(vals);
          return !!v && v.available;
        }
        return this.cfg.variants.some((v) => v.available && vals.every((x, i) => x === '' || v.options[i] === x));
      }

      update() {
        const tier = this.tier;
        if (!tier) return;
        this.shown = tier;
        const rows = this.rows(tier);
        const used = {};
        let bad = [];
        let total = 0;
        let waiting = 0;
        rows.forEach((row, i) => {
          const vals = this.values(row);
          // grey out option values that can't be bought with this row's other choices
          row.querySelectorAll('.aa-bundle__select').forEach((sel, j) => {
            Array.from(sel.options).forEach((o) => {
              if (o.value === '') return;
              const test = vals.slice();
              test[j] = o.value;
              o.disabled = !this.canBuy(test) && o.value !== sel.value;
            });
          });
          const v = this.variantFor(vals);
          const msg = row.querySelector('.aa-bundle__msg');
          let text = '';
          const blank = vals.indexOf('');
          let quiet = false;
          if (blank > -1) {
            // a menu still on its name: say which, once the shopper has tried to add
            const sel = row.querySelectorAll('.aa-bundle__select')[blank];
            const name = sel && sel.options[0] ? sel.options[0].textContent.trim().toLowerCase() : '';
            text = (this.cfg.strings.pick || '').replace('[option]', name).replace('[unit]', this.cfg.unit.toLowerCase()).replace('[n]', i + 1);
            quiet = !this.tried;
            waiting++;
            total += this.cfg.variants[0].price;
          } else if (!v || !v.available) {
            text = this.fill(this.cfg.strings.soldOut, i + 1, v ? v.title : vals.join(' / '), 0);
          } else {
            used[v.id] = (used[v.id] || 0) + 1;
            if (v.stock !== null && used[v.id] > v.stock) text = this.fill(this.cfg.strings.only, i + 1, v.title, v.stock);
          }
          if (v) total += v.price;
          msg.hidden = !text || quiet;
          msg.textContent = text;
          if (text) bad.push(i + 1);
          row.querySelectorAll('.aa-bundle__select').forEach((s) => {
            if (text && !quiet) {
              s.setAttribute('aria-invalid', 'true');
              s.setAttribute('aria-describedby', msg.id || (msg.id = 'aa-msg-' + Math.random().toString(36).slice(2)));
            } else {
              s.removeAttribute('aria-invalid');
              s.removeAttribute('aria-describedby');
            }
          });
        });
        this.bad = bad;
        this.price(tier, total);
        const first = rows[0] && this.variantFor(this.values(rows[0]));
        if (this.form && first) {
          const id = this.form.querySelector('[name="id"]');
          if (id) id.value = first.id;
        }
        const btn = this.form && this.form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('aria-disabled', bad.length ? 'true' : 'false');
        // a menu still on its name has its own line; the hint is for choices that can't be bought
        if (bad.length > waiting) this.status.textContent = this.cfg.strings.change.replace('[unit]', this.cfg.unit).replace('[n]', bad.join(', '));
        this.syncMenus();
      }

      price(tier, full) {
        const pct = parseFloat(tier.dataset.pct) || 0;
        const fixed = parseInt(tier.dataset.fixed, 10) || 0;
        let now = full;
        if (pct > 0) now = full - Math.round((full * pct) / 100);
        else if (fixed > 0 && fixed < full) now = fixed;
        const save = full - now;
        tier.querySelector('[data-now]').textContent = this.money(now);
        tier.querySelector('[data-was]').textContent = this.money(full);
        tier.querySelector('[data-save]').textContent = this.money(save);
        tier.querySelector('.aa-bundle__was').hidden = save <= 0;
        tier.querySelector('.aa-bundle__save').hidden = save <= 0;
      }

      fill(tpl, n, title, k) {
        return tpl.replace('[unit]', this.cfg.unit).replace('[n]', n).replace('[variant]', title).replace('[k]', k);
      }

      money(cents) {
        const sample = this.cfg.money; // the shop's format for 1234.56
        const m = sample.match(/1([^\d]?)234(?:([^\d])56)?/);
        if (!m) return (cents / 100).toFixed(2);
        const thou = m[1] || '';
        const dec = m[2] || '';
        const whole = Math.floor(cents / 100)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        const amount = dec ? whole + dec + String(cents % 100).padStart(2, '0') : whole;
        return sample.replace(m[0], amount);
      }

      findGuide(heading) {
        if (!heading) return null;
        const scope = this.closest('.product__info-container') || document;
        return (
          Array.from(scope.querySelectorAll('details')).find((d) => {
            const s = d.querySelector('summary');
            return s && s.textContent.toLowerCase().includes(heading.toLowerCase());
          }) || null
        );
      }

      openGuide(heading) {
        const d = this.findGuide(heading);
        if (!d) return;
        d.open = true;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        const s = d.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      }

      onSubmit(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const btn = this.form.querySelector('[type="submit"]');
        if (this.busy) return;
        if (!this.tried) {
          this.tried = true;
          this.update();
        }
        if (this.bad && this.bad.length) {
          const row = this.rows()[this.bad[0] - 1];
          const s = row && (row.querySelector('.aa-bdd__btn') || row.querySelector('.aa-bundle__select'));
          if (s) s.focus();
          return;
        }
        const counts = {};
        const order = [];
        this.rows().forEach((row) => {
          const v = this.variantFor(this.values(row));
          if (!v) return;
          if (!counts[v.id]) order.push(v.id);
          counts[v.id] = (counts[v.id] || 0) + 1;
        });
        if (!order.length) return;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = { items: order.map((id) => ({ id, quantity: counts[id] })) };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        this.busy = true;
        this.status.textContent = '';
        const spinner = this.form.querySelector('.loading__spinner');
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.status) {
              this.status.textContent = res.description || res.message || this.cfg.strings.error;
              return;
            }
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aa-bundle-picker', productVariantId: order[0], cartData: res });
            }
            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.showCart(cart, res);
          })
          .catch(() => {
            this.status.textContent = this.cfg.strings.error;
          })
          .finally(() => {
            this.busy = false;
            btn.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            this.update();
          });
      }

      // the pop-up's heading counts what was added: "3 pairs added to your cart"
      countHeading(cart, items) {
        const h = cart.querySelector('.cart-notification__heading');
        if (!h) return;
        const node = Array.from(h.childNodes).reverse().find((n) => n.nodeType === 3 && n.textContent.trim());
        if (!node) return;
        if (!h.dataset.aaText) h.dataset.aaText = node.textContent;
        const count = items.reduce((sum, i) => sum + (i.quantity || 0), 0);
        const unit = (this.cfg.unit || '').toLowerCase();
        node.textContent = count > 1 && unit ? ` ${count} ${unit}s added to your cart` : h.dataset.aaText;
      }

      showCart(cart, res) {
        const items = res.items || [];
        if (!items.length) return;
        if (cart.tagName === 'CART-NOTIFICATION' && res.sections) {
          // show every line just added, not only the first
          const keys = Array.from(new Set(items.map((i) => i.key)));
          cart.cartItemKey = keys[0];
          cart.getSectionsToRender().forEach((section) => {
            const el = document.getElementById(section.id);
            const html = res.sections[section.id];
            if (!el || !html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (section.id === 'cart-notification-product') {
              el.innerHTML = keys
                .map((k) => {
                  const n = doc.querySelector(`[id="cart-notification-product-${k}"]`);
                  return n ? n.outerHTML : '';
                })
                .join('');
            } else {
              const n = doc.querySelector('.shopify-section');
              if (n) el.innerHTML = n.innerHTML;
            }
          });
          this.countHeading(cart, items);
          if (cart.header) cart.header.reveal();
          cart.open();
          return;
        }
        cart.renderContents(Object.assign({ id: items[0].id, key: items[0].key }, res));
      }
    }
  );
}
